<div class="row">
  <div class="col-12">
    <h3>{{ "Template.DatastreamsComponent.subHeader_manageDatastreams" | translate }}</h3>
  </div>
</div>

@if (loading) {
  <div class="text-center p-5">
    <fa-icon icon="spinner" class="fa-spin" size="3x" animation="spin"></fa-icon>
  </div>
}

@if (dataStreams?.length && !loading) {
  <table class="table table-striped table-hover mt-3">
    <thead>
      <tr>
        <th width="30%" scope="col" sortable="name" [init]="true" (sort)="onSort($event)">
          <fa-icon class="asc" icon="sort-up"></fa-icon>
          <fa-icon class="desc" icon="sort-down"></fa-icon>
          <fa-icon icon="sort"></fa-icon>
          {{ "Template.DatastreamsComponent.text_dataSupplier" | translate }}
        </th>
        <th width="15%" class="text-center" scope="col" sortable="lastImportDate" (sort)="onSort($event)">
          <fa-icon class="asc" icon="sort-up"></fa-icon>
          <fa-icon class="desc" icon="sort-down"></fa-icon>
          <fa-icon icon="sort"></fa-icon>
          {{ "Template.DatastreamsComponent.text_lastImport" | translate }}
        </th>
        <th width="15%" class="text-center" scope="col" sortable="lastExportDate" (sort)="onSort($event)">
          <fa-icon class="asc" icon="sort-up"></fa-icon>
          <fa-icon class="desc" icon="sort-down"></fa-icon>
          <fa-icon icon="sort"></fa-icon>
          {{ "Template.DatastreamsComponent.text_lastExport" | translate }}
        </th>
        <th width="10%" class="text-center" scope="col" sortable="productCount" (sort)="onSort($event)">
          <fa-icon class="asc" icon="sort-up"></fa-icon>
          <fa-icon class="desc" icon="sort-down"></fa-icon>
          <fa-icon icon="sort"></fa-icon>
          {{ "Template.DatastreamsComponent.text_products" | translate }}
        </th>
        <th width="10%" class="text-center" scope="col">{{ "Template.DatastreamsComponent.text_logo" | translate }}</th>
        <th width="10%" class="text-center" scope="col">{{ "Template.DatastreamsComponent.text_retrievable" | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (dataStream of dataStreams; track dataStream) {
        <tr>
          <input type="hidden" name="dataStreamIds[]" value="{{ dataStream.id }}" />
          <td class="align-middle">
            {{ dataStream.supplier?.attributes?.['NAME'] }}
            <small class="d-block mb-1">
              {{ dataStream.supplier! | identification : "GLN" }}
            </small>
            @if (dataStream.supplierPartyId) {
              <a [routerLink]="['/app', 'admin', 'supplier', dataStream.supplierPartyId]" class="btn btn-link btn-sm">
                {{ "Template.DatastreamsComponent.btn_details" | translate }}
                <fa-icon icon="chevron-right"></fa-icon>
              </a>
            }
          </td>
          <td class="align-middle text-center">
            @if (dataStream.lastImportDate) {
              <div>
                <span class="d-block">{{ dataStream.lastImportDate | date : "dd.MM.yyyy" }}</span>
                <small class="d-block">{{ "Template.DatastreamsComponent.text_time" | translate : { time: dataStream.lastImportDate | date : "HH:mm" } }}</small>
              </div>
            }
            @if (!dataStream.lastImportDate) {
              <div>---</div>
            }
          </td>
          <td class="align-middle text-center">
            @if (dataStream.lastExportDate) {
              <div>
                <span class="d-block">{{ dataStream.lastExportDate | date : "dd.MM.yyyy" }}</span>
                <small class="d-block">{{ "Template.DatastreamsComponent.text_time" | translate : { time: dataStream.lastExportDate | date : "HH:mm" } }}</small>
              </div>
            }
            @if (!dataStream.lastExportDate) {
              <div>---</div>
            }
          </td>
          <td class="align-middle text-center">
            {{ dataStream.productCount | number }}
          </td>
          <td class="align-middle text-center">
            <div class="logo-image">
              @if (dataStream.logoImageUrl) {
                <button type="button" class="btn btn-link" ngbPopover="{{ 'Template.DatastreamsComponent.tooltip_logoAvailable' | translate }}" triggers="mouseenter:mouseleave">
                  <fa-icon icon="check" class="text-success"></fa-icon>
                </button>
              }
              @if (!dataStream.logoImageUrl) {
                <button type="button" class="btn btn-link" ngbPopover="{{ 'Template.DatastreamsComponent.tooltip_noLogoAvailable' | translate }}" triggers="mouseenter:mouseleave">
                  <fa-icon icon="xmark" class="text-danger"></fa-icon>
                </button>
              }
            </div>
          </td>
          <td class="align-middle text-center">
            @if (dataStream.autoApprove) {
              <div>
                <fa-icon icon="handshake" class="text-success" ngbPopover="{{ 'Template.DatastreamsComponent.tooltip_autoApprove' | translate }}" triggers="mouseenter:mouseleave"></fa-icon>
              </div>
            }
            @if (!dataStream.autoApprove) {
              <div>
                <fa-icon icon="handshake" class="text-warning" ngbPopover="{{ 'Template.DatastreamsComponent.tooltip_manualApprove' | translate }}" triggers="mouseenter:mouseleave"></fa-icon>
              </div>
            }
          </td>
        </tr>
      }
    </tbody>
    <caption>
      {{
      "Template.DatastreamsComponent.text_dataStreamsProductsDisabledProducts" | translate : { qtyDatastreams: dataStreams.length, qtyProducts: productCount | number }
      }}
    </caption>
  </table>
}
